import { HttpResponse, http, type HttpHandler } from 'msw';
import { BFF_ENDPOINTS } from '../../api/endpoints/BffEndpoints';
import { createMockStationGroupsList } from '../factories/geography';
import { toMSWPattern } from '../utils/generic';
import type { HTTP_METHODS } from './constants/generic';
import { HTTP_METHODS_VALUES } from './constants/generic';

interface HandlerMapping {
  pattern: string;
  key: string;
  method?: HTTP_METHODS;
}

export interface HandlerWithMapping {
  handler: HttpHandler;
  mapping: HandlerMapping;
}

export const ENDPOINTS_KEYS = {
  STATION_GROUPS: 'STATION_GROUPS',
};

export function createGeographyHandlers(baseUrl: string): HandlerWithMapping[] {
  return [
    {
      handler: http.get(`${baseUrl}/${toMSWPattern(BFF_ENDPOINTS.STATION_GROUPS)}`, () => {
        return HttpResponse.json(createMockStationGroupsList());
      }),
      mapping: {
        pattern: 'station-groups',
        key: ENDPOINTS_KEYS.STATION_GROUPS,
        method: HTTP_METHODS_VALUES.GET as HTTP_METHODS,
      },
    },
  ];
}
